/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import FormInput from '@components/inputs/formInput'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '@components/loading'
import showToast from '@util/ToastUtil'
import { createActivity as createActivityAction } from '@stores/actions/activity'

import {
  Container, Section, Field, Label, TextArea, Footer
} from './styles'

const CreateActivityModal = ({ isOpen, onClose, createActivity }) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const validate = () => {
    const err = {}
    if (!name.trim()) err.name = 'Informe o nome da atividade'
    setErrors(err)
    return Object.keys(err).length === 0
  }

  const handleSave = () => {
    if (!validate()) return
    setLoading(true)
    createActivity(
      { name: name.trim(), description: description.trim() || null },
      (data) => {
        setLoading(false)
        if (data) {
          showToast('success', 'Atividade criada com sucesso!')
          setName('')
          setDescription('')
          onClose && onClose()
        }
      }
    )
  }

  return (
    <Container isOpen={isOpen}>
      {/* HEADER */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px'
        }}
      >
        <h2
          style={{
            fontSize: '30px',
            fontWeight: '600',
            margin: 0,
            color: '#222'
          }}
        >
          Criar atividade
        </h2>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '22px',
            lineHeight: '1',
            cursor: 'pointer',
            color: '#555'
          }}
        >
          ×
        </button>
      </div>

      {/* CAMPOS */}
      <Section>
        <Field>
          <FormInput
            label="Nome da atividade"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={errors.name}
            required
          />
        </Field>

        <Field>
          <Label>Descrição (opcional)</Label>
          <TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={500}
            placeholder="Adicione alguma descrição da atividade"
          />
        </Field>
      </Section>

      {/* RODAPÉ */}
      <Footer>
        <PrimaryButton onClick={handleSave} disabled={loading}>
          {loading ? <Loading /> : 'Criar'}
        </PrimaryButton>
      </Footer>
    </Container>
  )
}

CreateActivityModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  createActivity: PropTypes.func.isRequired,
}

CreateActivityModal.defaultProps = { isOpen: false, onClose: null }

const mapDispatchToProps = (dispatch) => bindActionCreators({ createActivity: createActivityAction }, dispatch)

export default connect(null, mapDispatchToProps)(CreateActivityModal)
